import { ShapeDiverValue } from '../../shape-diver';

export function loadValues(): Record<string, ShapeDiverValue> {
  const jsonString = window.localStorage.getItem('REMEMBERED_VALUES');

  if (jsonString) return JSON.parse(jsonString);
  else return {};
}

export function rememberValues(values: Record<string, ShapeDiverValue>): void {
  const jsonString = JSON.stringify(values);
  window.localStorage.setItem('REMEMBERED_VALUES', jsonString);
}
